import * as r from 'ramda';

export const isTrue = r.equals(true);
export const isFalse = r.equals(false);
export const allPass = r.all(r.equals(true));
export const nuller = r.always(null);
export const whenTrue = r.when(isTrue);
export const whenFalse = r.when(isFalse);
export const ifElseBool = r.ifElse(isTrue);
export const notEquals = r.complement(r.equals);
